import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationModule';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';

export class WinPresentationFreeSpinsBasicState extends ModuleState<WinPresentationView, WinPresentationModule> {
    public onEnterState(): void {
    }

    public onLeaveState(): void {}

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.WON, this.onWon.bind(this));
        this.setEventHandler(
            FlowModuleEvents.SHOULD_START_INDIVIDUAL_WIN_AFTER_POPUP_FREESPINS,
            this.onShouldStartIndividualWin.bind(this)
        );
    }

    protected onWon(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_INITIAL_STATE);
    }

    protected onShouldStartIndividualWin(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_PAYS_STATE);
    }
}
